<spinner [visible]="progressVisible" [pleaseWaitText]="t.common('please_wait')"></spinner>

<div class="hw-div-center vertical-and-horizontal-center custom-card-container hw-roboto">
  <h3>{{t.refund("cancelOrderTitle")}}</h3>
  @if(activePageId> 0) {
  <div class="hw-text-align-center">
    <img [class]="`payment-options-icon ${orderedItems.paymentProvider}`" width="70"
      [src]="getPaymentOptionIconUrlByType(orderedItems.paymentProvider)" />
  </div>
  }

  <hr class="custom-divider">

  @switch (activePageId) {
  @case (0) {
  <div [formGroup]="form" class="w-100 hw-padding-top-1em">

    <div class="hw-block w-100">
      <div fxLayout="row wrap">
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100"
          class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.refund("email")}}</mat-label>
            <input type="email" [maxlength]="getMaxLength(formSettings, 'email')" matInput formControlName="email"
              name="email">
            @if (checkFormHasRequiredError(form, 'email')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkFormHasServerError(form, 'email')) {
            <mat-error>
              {{getServerError("email")}}
            </mat-error>
            }
            @if (checkFormHasMaxLengthError(form, 'email')) {
            <mat-error>
              {{getMaxLengthErrorMessage(form, 'email')}}
            </mat-error>
            }
            @if(checkFormHasEmailError(form, 'email')) {
            <mat-error>
              {{t.errors("ERR_EMAIL")}}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap">
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100"
          class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.refund("invoiceNumber")}}</mat-label>
            <input type="text" [maxlength]="getMaxLength(formSettings, 'invoiceNumber')" matInput
              formControlName="invoiceNumber" name="invoiceNumber">
            @if (checkFormHasRequiredError(form, 'invoiceNumber')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if (checkFormHasServerError(form, 'invoiceNumber')) {
            <mat-error>
              {{getServerError("invoiceNumber")}}
            </mat-error>
            }
            @if (checkFormHasMaxLengthError(form, 'invoiceNumber')) {
            <mat-error>
              {{getMaxLengthErrorMessage(form, 'invoiceNumber')}}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap">
        <div fxFlex="100" fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="100" fxFlex.lg="100" fxFlex.xl="100"
          class="hw-width-100 input-field-style">
          <mat-form-field appearance="outline" floatLabel="always" class="hw-width-100">
            <mat-label>{{t.refund("transactionIdentifier")}}</mat-label>
            <input type="text" [maxlength]="getMaxLength(formSettings, 'transactionId')" matInput
              formControlName="transactionId" name="transactionId">
            @if(checkFormHasRequiredError(form, 'transactionId')) {
            <mat-error>
              {{t.errors("ERR_REQUIRED")}}
            </mat-error>
            }
            @if(checkFormHasServerError(form, 'transactionId')) {
            <mat-error>
              {{getServerError("transactionId")}}
            </mat-error>
            }
            @if(checkFormHasMaxLengthError(form, 'transactionId')) {
            <mat-error>
              {{getMaxLengthErrorMessage(form, 'transactionId')}}
            </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

    </div>
  </div>

  <button [disabled]="!form.valid" mat-raised-button (click)="getItemList()"
    class="hw-step-button-margin custom-next-button hw-width-100 mat-step-buttons">
    <mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon>{{t.common("next")}}
  </button>

  }

  @case (1) {
  @if(orderedItems) {
  <div class="cart-container w-100">
    @for(item of orderedItems.items; track item) {
    <div class="cart-item">
      <div class="item-info">
        <span class="item-name">{{item.ticketName}}</span>
        <span class="item-date">{{item.date | date:'yyyy. MM. dd.'}}</span>
      </div>
      <div class="item-pricing">
        <div class="quantity-badge">
          {{item.quantity}} {{item.unit}}
        </div>
        <div class="item-price">
          {{item.unitPrice |number:undefined:currLocale}} {{item.currency.symbol}}
          <br>
          <span class="hw-font-size-18px">
            {{(item.amount |number:undefined:currLocale) + " " + item.currency.symbol }}
          </span>
        </div>
      </div>
    </div>

    @if(item.usedQuantity > 0){
    <div class="cart-item color-red">
      <div class="item-info">
        <span class="item-name color-red">{{t.refund("used")}}</span>
      </div>
      <div class="item-pricing">
        <div class="quantity-badge">
          {{item.usedQuantity}} {{item.unit}}
        </div>
        <div class="item-price">
          <span class="hw-font-size-18px">
            {{((item.usedQuantity*item.unitPrice *-1) |number:undefined:currLocale) + " " + item.currency.symbol }}
          </span>
        </div>
      </div>
    </div>
    }
    <hr class="custom-divider">
    }

    <div class="cart-summary-row hw-padding-top-1em">
      <span class="summary-label">{{t.refund("payedAmount")}}:</span>
      <span class="summary-value">
        {{orderedItems.summary.amount |number:undefined:currLocale}}
        {{orderedItems.summary.currency.symbol}}
      </span>
    </div>

    <div class="cart-summary-row">
      <span class="summary-label">{{t.refund("refundAmount")}}:</span>
      <span class="summary-value refund-highlight">
        {{orderedItems.summary.refundAmount |number:undefined:currLocale}}
        {{orderedItems.summary.currency.symbol}}
      </span>
    </div>
  </div>
  }

  @if(!cancelOrderSuccess) {
  <div class="button-row-container row-layout-full hw-padding-top-2em">
    <button mat-raised-button class="hw-step-button-margin custom-next-button hw-width-100 mat-step-buttons"
      (click)="backToInvoiceData()">
      <mat-icon iconPositionStart class="mdi mdi-chevron-left"></mat-icon>{{t.common("back")}}
    </button>

    <button [disabled]="!form.valid" mat-raised-button
      class="hw-step-button-margin custom-next-button hw-width-100 mat-step-buttons" (click)="refund()">
      {{t.common("next")}}<mat-icon iconPositionEnd class="mdi mdi-chevron-right"></mat-icon>
    </button>
  </div>
  }
  }

  @case (2) {


  @if (cancelOrderSuccess) {
  <div>
    <span class="mdi mdi-check-circle-outline success-icon"></span>
    <br>
    <span class="success-title">
      {{"shopping.payment_success_title" | translate}}
    </span>
    <br>
    <br>
    <span class="success-text">
      {{refundObject?.paymentStatusMessage}}
    </span>
  </div>
  } @else {
  <div>
    <span class="mdi mdi-close-circle-outline error-icon"></span>
    <br>
    <span class="error-title">
      {{"shopping.payment_error_title" | translate}}
    </span>
    <br>
    <br>
    <span class="error-text">
      {{refundObject?.paymentStatusMessage}}
    </span>
  </div>
  }

  @if(refundObject?.providerTransactionId){
  <br>
  <div class="transaction-text hw-padding-10px">
    <div class="hw-font-weight-700 hw-margin-bottom-5px">{{"shopping.transactionId" | translate}}</div>
    <div>{{refundObject?.providerTransactionId}}</div>
  </div>
  }

  @if(orderedItems.paymentProvider === "OTPSimple" && refundObject?.providerTransactionId)
  {
  <br>
  <div class="transaction-text hw-padding-10px">
    <div class="hw-font-weight-700 hw-margin-bottom-5px">{{"shopping.otpSimplepaytransactionId" | translate}}</div>
    <div>{{refundObject?.providerTransactionId}}</div>
  </div>
  }
  @if(!cancelOrderSuccess)
  {
  <button mat-raised-button color="accent" class="mat-step-buttons" (click)="backToInvoiceItems()">
    <mat-icon class="mdi mdi-chevron-left"></mat-icon>{{t.common("back")}}
  </button>
  }
  }
  }

  @if(subscriberInfo && subscriberInfo.contacts) {
  <div class="tel-header hw-border-top">
    <p>{{"shopping.support" | translate}}:</p>
    <a mat-raised-button class="hw-mat-tel-btn" [href]="'tel:' + subscriberInfo.contacts.PhoneNumber">
      <mat-icon>phone</mat-icon>
      {{subscriberInfo.contacts.PhoneNumber}}
    </a>
  </div>
  }
</div>